import * as React from "react"
import * as $ from "jquery"
import { HabitPrescriptionItemRequest } from "@curefit/gmf-common"
import {IDoctorCheckInInfo} from "@curefit/care-common";
import ModelFactory from "../../../models/ModelFactory"
import CustomHeader, {ICustomHeaderInfo} from "../../utils/CustomHeader"
import TextInput from "../../TextInput"
import {ChangeEvent} from "react"
import {AppConstants, AppPlaceholders} from "../../../utils/AppConstants"
import * as _ from "lodash"
import IStaticDataValue from "../../../../../common/models/IStaticDataValue"
import {TypeAheadElement} from "../../TypeAhead"
import DurationComponent from "../../DurationComponent";
import TemplatedList from "../../TemplatedList";
import {IFollowup, IReferral} from "../../../models/LCPlanClientModels";

/**
 * Created by aditya on 06/02/18.
 */

let AdditionalInstructionsHeaderInfos: ICustomHeaderInfo[] = [
    {label: "speciality", display: "SPECIALITY", mandatory: true},
    {label: "reason", display: "REASON"},
    {label: "when", display: "WHEN"}
];

let AdditionalInstructionsHeaderInfosForKMH: ICustomHeaderInfo[] = [
    {label: "speciality", display: "SPECIALITY"},
    {label: "type", display: "CONSULTATION TYPE"},
    {label: "reason", display: "REASON"},
    {label: "when", display: "WHEN"},
    {label: "reminder", display: "REMIND"}
];

let AdditionalInstructionsSecondaryHeaderInfos: ICustomHeaderInfo[] = [
    {label: "followUp", display: "FOLLOW UP"},
    {label: "safetyNetting", display: "SAFETY NETTING"}
];

export interface PatientAdditionalInstructionsEditorProps {
    updateSavedReferrals: (updatedReferral: {item: IDoctorCheckInInfo}[]) => void,
    consultationType: string,
    updatedFollowUp: {item: IFollowup}[],
    updatedReferral: {item: IReferral}[],
    immediateFollowUp: boolean,
    updateReferral: (updatedReferral: {item: IReferral}[]) => void,
    updateFollowUp: (updatedFollowUp: {item: IFollowup}[]) => void,
    staticSpecialities: any[],
    updateImmediateFollowUp: () => void
}

export interface PatientAdditionalInstructionsEditorState {
    validate: boolean
}

class PatientAdditionalInstructionsEditor extends React.Component<PatientAdditionalInstructionsEditorProps, PatientAdditionalInstructionsEditorState> {
    private followUpDOM: any;

    constructor(props: PatientAdditionalInstructionsEditorProps) {
        super(props);
        this.state = {
            validate: false
        }
    }

    componentDidMount() {
        let myInstance = this;
        $(this.followUpDOM).find("input").on("blur", function() {
            setTimeout(function() {
                if ( $(myInstance.followUpDOM).find("input:focus").length === 0 ) {
                    myInstance.setState({validate: true})
                }
            }, 100)
        })
    }

    onFollowUpChange = (event: ChangeEvent<HTMLInputElement>) => {
        let count = isNaN(parseInt(event.target.value)) ? null : parseInt(event.target.value);
        let updatedItem = [...this.props.updatedFollowUp];
        updatedItem[0].item.followUp = { count, unit: "DAY" }
        this.props.updateFollowUp(updatedItem);
    }

    onFollowUpUnitChange = (value: string) => {
        let duration = this.props.updatedFollowUp[0] && this.props.updatedFollowUp[0].item && !_.isEmpty(this.props.updatedFollowUp[0].item.followUp) ? this.props.updatedFollowUp[0].item.followUp : ModelFactory.createNewFrequency();
        duration = { ...duration, unit: value };
        let updatedItem = this.props.updatedFollowUp[0].item ? { ...this.props.updatedFollowUp[0].item, followUp: duration } : { followUp: duration };
        this.props.updateFollowUp([{item: updatedItem}]);
    }

    onFollowUpActivityDateChange = (elem: TypeAheadElement) => {
        let duration = elem.others.value;
        let updatedItem = this.props.updatedFollowUp[0].item ? { ...this.props.updatedFollowUp[0].item, followUp: duration } : { followUp: duration };
        this.props.updateFollowUp([{item: updatedItem}]);
    }

    onFollowUpSafetyNettingChange = (event: ChangeEvent<HTMLInputElement>) => {
        let updatedItem = { ...this.props.updatedFollowUp[0].item, comment: event.target.value };
        this.props.updateFollowUp([{item: updatedItem}]);
    }

    toggleImmediateFollowUp = () => {
        this.props.updateImmediateFollowUp();
    }

    generateFrequencyUnitItems = (): IStaticDataValue[] => {
        let staticDataValues: IStaticDataValue[] = [];
        _.map(AppConstants.FrequencyUnit, (month, key) => {
            let staticDataItem = ModelFactory.createNewStaticItem();
            staticDataItem.internalValue = key;
            staticDataItem.displayValue = month;
            staticDataValues.push(staticDataItem)
        })
        return staticDataValues;
    }

    onReferralRemove = (index: number) => {
        let currUpdatedLifeStyle = Object.assign([], this.props.updatedReferral);
        currUpdatedLifeStyle.splice(index, 1);
        this.props.updateReferral(currUpdatedLifeStyle);
    }

    onReferralChange = (updatedReferral: IDoctorCheckInInfo, index: number) => {
        let currUpdatedLifeStyle = Object.assign([], this.props.updatedReferral);
        currUpdatedLifeStyle[index] = updatedReferral;
        this.props.updateReferral(currUpdatedLifeStyle);
    }

    render() {
        let headerInfos = this.props.consultationType === AppConstants.ConsultationTypes.KMH ? AdditionalInstructionsHeaderInfosForKMH : AdditionalInstructionsHeaderInfos;
        const hasItem = !_.isEmpty(this.props.updatedFollowUp) && !_.isEmpty(this.props.updatedFollowUp[0].item);
        let numOfDays = hasItem && !_.isEmpty(this.props.updatedFollowUp[0].item.followUp) ?
            this.props.updatedFollowUp[0].item.followUp.count : null;
        let followUpUnit = hasItem && !_.isEmpty(this.props.updatedFollowUp[0].item.followUp) ?
            this.props.updatedFollowUp[0].item.followUp.unit : null;
        let safetyNetting =  hasItem && !_.isEmpty(this.props.updatedFollowUp[0].item.comment) ? this.props.updatedFollowUp[0].item.comment : "";
        // let followUpItemValidationStatus = this.state.validate && !ModelFactory.isValidFollowUp(this.props.updatedFollowUp.item) ? "error" : "";

        return (
            <div className="patient-referral-editor">
                <CustomHeader headerInfos={headerInfos} rootCls={"patient-referral"}/>
                <TemplatedList templateName={"doctorReferral"} commonProps={{consultationType: this.props.consultationType, staticSpecialities: this.props.staticSpecialities}}
                               defaultItem={{item: ModelFactory.createReferralItem()}}
                               listItems={this.props.updatedReferral}
                               onItemRemove={this.onReferralRemove}
                               onItemChange={this.onReferralChange}/>

                <CustomHeader headerInfos={AdditionalInstructionsSecondaryHeaderInfos} rootCls={"patient-follow-up"}/>
                <div className={"patient-follow-up-item-editor"} ref={(followUpDOM) => this.followUpDOM = followUpDOM}>
                    <div className={`patient-follow-up-days-container`}>
                        <DurationComponent unit={followUpUnit} count={numOfDays}
                                           rootClass={"follow-up"} onCountChange={this.onFollowUpChange}
                                           onUnitChange={this.onFollowUpUnitChange}
                                           onDurationChange={this.onFollowUpActivityDateChange}/>
                    </div>
                    <div className={"patient-follow-up-safety-netting"}>
                        <TextInput name="patient-follow-up-safety-netting" onChange={this.onFollowUpSafetyNettingChange} value={safetyNetting} placeholder={AppPlaceholders.ADDITIONAL_INSTRUCTIONS_EDITVIEW_FOLLOW_UP_SAFETY_NETTING} />
                    </div>
                </div>

                <div className={"patient-immediate-followUp-container"}>
                    <span className={"immediate-followUp"}>
                        <input type="checkbox" checked={this.props.immediateFollowUp} onChange={this.toggleImmediateFollowUp} />
                        <span>Immediate Follow up</span>
                    </span>
                </div>
            </div>
        );
    }
}

export default PatientAdditionalInstructionsEditor;